export default function Card({ className = '', children, ...props }) {
  return (
    <div
      className={`bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-lg ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}
